import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinKelompokKegiatan = createAsyncThunk(
    "kelompokKegiatan/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterKelompokKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getKelompokKegiatan = createAsyncThunk(
    "kelompokKegiatan/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterKelompokKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertKelompokKegiatan = createAsyncThunk(
    "kelompokKegiatan/insert",
    async ({NamaKelompokKegiatan}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaKelompokKegiatan", NamaKelompokKegiatan);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterKelompokKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateKelompokKegiatan = createAsyncThunk(
    "kelompokKegiatan/update",
    async ({NamaKelompokKegiatan, KelompokKegiatanID, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("NamaKelompokKegiatan", NamaKelompokKegiatan);
        formData.append("KelompokKegiatanID", KelompokKegiatanID);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterKelompokKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const kelompokKegiatanSlice = createSlice({
    name: "kelompokKegiatan",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinKelompokKegiatan.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinKelompokKegiatan.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinKelompokKegiatan.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getKelompokKegiatan.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getKelompokKegiatan.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getKelompokKegiatan.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertKelompokKegiatan.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertKelompokKegiatan.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertKelompokKegiatan.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateKelompokKegiatan.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateKelompokKegiatan.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateKelompokKegiatan.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const kelompokKegiatanSelector = (state) => state.kelompokKegiatan;
